import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-268d2e92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "[ export cv ]", -1))
const _hoisted_4 = { class: "panel-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "presets:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "sections:", -1))
const _hoisted_8 = { class: "check-row" }
const _hoisted_9 = { class: "check-row" }
const _hoisted_10 = {
  key: 0,
  class: "sub-checks"
}
const _hoisted_11 = { class: "check-row" }
const _hoisted_12 = { class: "check-row" }
const _hoisted_13 = { class: "check-row" }
const _hoisted_14 = {
  key: 0,
  class: "sub-checks"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " filter by tech (applies to projects & open source): ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "pdf style:", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  key: 0,
  class: "style-note"
}
const _hoisted_19 = { class: "export-row" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 1,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "overlay",
    onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "[x]")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.applyPreset('full')))
          }, "[ full cv ]"),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyPreset('technical')))
          }, " [ technical ] "),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.applyPreset('recent')))
          }, " [ recent only ] ")
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sel.cv) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.sel.cv]
            ]),
            _createTextVNode(" curriculum vitae ")
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sel.about) = $event)),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onAboutChange && _ctx.onAboutChange(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.sel.about]
            ]),
            _createTextVNode(" about ")
          ]),
          (_ctx.sel.about)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sel.aboutContacts) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.aboutContacts]
                  ]),
                  _createTextVNode(" contacts ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sel.aboutWhoIAm) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.aboutWhoIAm]
                  ]),
                  _createTextVNode(" who i am ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sel.aboutEducation) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.aboutEducation]
                  ]),
                  _createTextVNode(" education ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sel.aboutSkills) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.aboutSkills]
                  ]),
                  _createTextVNode(" skills ")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sel.opensource) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.sel.opensource]
            ]),
            _createTextVNode(" open source ")
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.sel.blog) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.sel.blog]
            ]),
            _createTextVNode(" blog posts ")
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sel.projects) = $event)),
              onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onProjectsChange && _ctx.onProjectsChange(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.sel.projects]
            ]),
            _createTextVNode(" projects ")
          ]),
          (_ctx.sel.projects)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sel.projects2020) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.projects2020]
                  ]),
                  _createTextVNode(" 2020+ ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sel.projects2015) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.projects2015]
                  ]),
                  _createTextVNode(" 2015–2019 ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sel.projects2010) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.projects2010]
                  ]),
                  _createTextVNode(" 2010–2014 ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.sel.projects2000) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.sel.projects2000]
                  ]),
                  _createTextVNode(" 2000–2009 ")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          class: "tech-input",
          type: "text",
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.techFilter) = $event)),
          placeholder: "e.g. rust, react, aws"
        }, null, 512), [
          [_vModelText, _ctx.techFilter]
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { active: _ctx.pdfStyle === 'professional' }]),
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.pdfStyle = 'professional'))
          }, " [ professional ] ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { active: _ctx.pdfStyle === 'compact' }]),
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.pdfStyle = 'compact'))
          }, " [ compact ] ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { active: _ctx.pdfStyle === 'classic' }]),
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.pdfStyle = 'classic'))
          }, " [ classic ] ", 2)
        ]),
        (_ctx.pdfStyle === 'classic')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " classic: formal layout with photo, matches the official cv "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn export-btn",
            disabled: _ctx.loading,
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.exportPdf && _ctx.exportPdf(...args)))
          }, _toDisplayString(_ctx.loading ? '[ generating... ]' : '[ export pdf ]'), 9, _hoisted_20),
          _createElementVNode("button", {
            class: "btn export-btn",
            disabled: _ctx.loading,
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.exportMarkdown && _ctx.exportMarkdown(...args)))
          }, " [ export markdown ] ", 8, _hoisted_21)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}